export const activitiesListSiteCoreKeys = {
  activitiesList: "Projects.CreateNewProject.ActivitiesList",
  activitiesTabText: "ActivitiesList.ActivitiesTabText",
  deliverablesTabText: "ActivitiesList.DeliverablesTabText",
  addActivityButton: "ActivitiesList.AddActivityButton",
  activityType: "ActivitiesList.ActivityType",
  modality: "ActivitiesList.Modality",
  topic: "ActivitiesList.Topic",
  projectFramework: "ActivitiesList.ProjectFramework",
  activityStatus: "ActivitiesList.ActivityStatus",
  units: "ActivitiesList.Units",
  measurement: "ActivitiesList.Measurement",
  action: "ActivitiesList.Action",
  activitiesNotAvailable: "ActivitiesList.ActivitiesNotAvailable",
  deleteActivityCompletionText: "ActivitiesList.DeleteActivityCompletionText",
  deletingActivity: "ActivitiesList.DeletingActivity",
  deleteActivityActionText: "ActivitiesList.DeleteActivityActionText",
  activityCannotBeDeleted:
    "ActivitiesList.ThisActivityCannotBeDeletedBecauseItIsTaggedToAnExistingProject",

  activityTypeList: "ActivitiesList.ActivityTypeList",
  minutesList: "ActivitiesList.MinutesList",
  modalityList: "ActivitiesList.ModalityList",
  statusList: "ActivitiesList.StatusList",
  unitList: "ActivitiesList.UnitLists",
};

export const deliverablesListSiteCoreKeys = {
  deliverablesList: "Projects.CreateNewProject.DeliverablesList",
  addDeliverablesLinkText: "DeliverablesList.AddDeliverablesLinkText",
  deliverableName: "DeliverablesList.DeliverableName",
  deliverableType: "DeliverablesList.DeliverableType",
  units: "DeliverablesList.Units",
  measurement: "DeliverablesList.Measurement",
  action: "DeliverablesList.Action",
  deleteDeliverableActionText: "DeliverablesList.DeleteDeliverableActionText",
  deleteDeliverableSuccessText: "DeliverablesList.DeleteDeliverableSuccessText",
  deletingDeliverableText: "DeliverablesList.DeletingDeliverableText",
  deliverablesNotAvailable: "DeliverablesList.DeliverablesNotAvailable",
  activityType: "DeliverablesList.ActivityType",
  activityTypeList: "DeliverablesList.ActivityTypeList",
  deliverableTypeList: "DeliverablesList.DeliverableTypeList",
  minutesList: "DeliverablesList.MinutesList",
  unitsList: "DeliverablesList.UnitsList",
};

export const addActivitySiteCoreKeys = {
  addActivity: "Projects.CreateNewProject.AddActivity",
  editActivityPopupTitle: "AddActivity.EditActivityPopupTitle",
  viewActivityPopupTitle: "AddActivity.ViewActivityPopupTitle",
  projectSpecificActivityNote:
    "AddActivity.ThisWillBeAProjectSpecificActivityNote",
  activityType: "AddActivity.ActivityType",
  modality: "AddActivity.Modality",
  topic: "AddActivity.Topic",
  localeTopicHeading: "AddActivity.LocaleTopicHeading",
  deliverables: "AddActivity.Deliverables",
  noDeliverablesAvailable: "AddActivity.NoDeliverablesAvailable",
  noTaggedDeliverablesTooltip:
    "AddActivity.YouHaventTaggedAnyDeliverablesToThisActivityYetTooltipMessage",
  activityStatus: "AddActivity.ActivityStatus",
  defaultActivityValues: "AddActivity.DefaultActivityValues",
  selectPreferencesHeading: "AddActivity.SelectPreferencesHeading",
  selectedPreferencesHeading: "AddActivity.SelectedPreferencesHeading",
  triggerBilling: "AddActivity.TriggerBilling",
  countsTowardsLastContactDate: "AddActivity.CountsTowardsLastContactDate",
  triggerTouchPointSurvey: "AddActivity.TriggerTouchPointSurvey",
  activityAddedMessage: "AddActivity.ActivityAddedMessage",
  activityUpdatedMessage: "AddActivity.ActivityUpdatedMessage",
  editActivityButton: "AddActivity.EditActivityButton",
  updateLocale: "AddActivity.UpdateLocale",
  updateLocaleActionMessage: "AddActivity.UpdateLocaleActionMessage",

  activityTypeList: "AddActivity.ActivityTypeList",
  modalityList: "AddActivity.ModalityList",
  statusList: "AddActivity.StatusList",

  ThisIsAFrameworkLevelActivity: "AddActivity.ThisIsAFrameworkLevelActivity",
  ThisIsAProjectSpecificActivity: "AddActivity.ThisIsAProjectSpecificActivity",
};

export const addDeliverableSiteCoreKeys = {
  addDeliverable: "Projects.CreateNewProject.AddDeliverable",
  activityType: "AddDeliverable.ActivityType",
  addDeliverableHeading: "AddDeliverable.AddDeliverableHeading",
  editDeliverableHeading: "AddDeliverable.EditDeliverableHeading",
  viewDeliverableHeading: "AddDeliverable.ViewDeliverableHeading",
  projectSpecificDeliverableNote:
    "AddDeliverable.ThisWillBeAProjectSpecificDeliverableNote",
  selectType: "AddDeliverable.SelectType",
  addNewDeliverableRadioButton: "AddDeliverable.AddNewDeliverableRadioButton",
  selectExistingDeliverablesRadioButton:
    "AddDeliverable.SelectExistingDeliverablesRadioButton",
  deliverableType: "AddDeliverable.DeliverableType",
  deliverableName: "AddDeliverable.DeliverableName",
  deliverableNameLocale: "AddDeliverable.DeliverableNameLocale",
  units: "AddDeliverable.Units",
  measurement: "AddDeliverable.Measurement",
  deliverablesSelected: "AddDeliverable.DeliverablesSelected",
  existingDeliverablesHeading: "AddDeliverable.ExistingDeliverablesHeading",
  deliverableAddedMessage: "AddDeliverable.DeliverableAddedMessage",
  deliverableNotUpdatedMessage: "AddDeliverable.DeliverableNotUpdatedMessage",
  deliverableSaveAlertMessage: "AddDeliverable.DeliverableSaveAlertMessage",
  deliverableUpdatedMessage: "AddDeliverable.DeliverableUpdatedMessage",
  minutes: "AddDeliverable.Minutes",
  numberOfDays: "AddDeliverable.NumberOfDays",
  quantity: "AddDeliverable.Quantity",
  editDeliverableButtonText: "AddDeliverable.EditDeliverableButtonText",

  deliverableTypeList: "AddDeliverable.DeliverableTypeList",
  minutesList: "AddDeliverable.MinutesList",
  unitsList: "AddDeliverable.UnitsList",
  thisIsAFrameworkLevelDeliverable:
    "AddDeliverable.ThisIsAFrameworkLevelDeliverable",
  thisIsAProjectSpecificDeliverable:
    "AddDeliverable.ThisIsAProjectSpecificDeliverable",
};

export const defaultActivityValuesSiteCoreKeys = {
  defaultActivityValues: "Projects.CreateNewProject.DefaultActivityValues",
  units: "DefaultActivityValues.Units",
  minutes: "DefaultActivityValues.Minutes",
  quantity: "DefaultActivityValues.Quantity",
  numberOfDays: "DefaultActivityValues.NumberofDays",
  halfDay: "DefaultActivityValues.HalfDay",

  minutesList: "DefaultActivityValues.MinutesList",
  unitLists: "DefaultActivityValues.UnitLists",
};
